module.exports = __webpack_public_path__ + "img/material.6ef51f7f.png";